import {Alert} from 'react-bootstrap'
import {DeactivateAccount} from '../../../../modules/accounts/components/settings/cards/DeactivateAccount'
import {IAllUserNode} from '../../../types/users'
import {ProfileDetailsSetting} from './ProfileDetailsSetting'
import {ChangePassword} from './ChangePassword'
import {ForcePasswordChangeCard} from './ForcePasswordChangeCard'

interface ISettingProps {
  node: IAllUserNode
  refetch: () => void
  setTabs: (TTabsOneUser) => void
}

export const SettingsTab: React.FC<ISettingProps> = ({node, refetch}) => {
  return (
    <>
      <ProfileDetailsSetting node={node} refetch={refetch} />
      <Alert variant='danger' className='my-5'>
        <Alert.Heading className='d-flex flex-center gap-2'>
          <i className='bi bi-exclamation-triangle fs-1' style={{color: 'inherit'}} />
          Dangerous zone
        </Alert.Heading>
      </Alert>
      <ChangePassword id={node.id} refetch={refetch} />
      <ForcePasswordChangeCard
        userId={node.id}
        forcePasswordChange={node.forcePasswordChange}
        onUpdated={refetch}
      />
      <DeactivateAccount userId={node.id} isActive={node.isActive} onStatusChanged={refetch} />
    </>
  )
}
